var map = {
	"./compiled-lang/de-DE.json": [
		95542,
		5542
	],
	"./compiled-lang/en-GB.json": [
		83444,
		3444
	],
	"./compiled-lang/en-US.json": [
		24125,
		4125
	],
	"./compiled-lang/ja-JP.json": [
		48613,
		8613
	],
	"./lang/de-DE.json": [
		52408,
		2408
	],
	"./lang/en-GB.json": [
		25858,
		5858
	],
	"./lang/en-US.json": [
		40023,
		23
	],
	"./lang/ja-JP.json": [
		88807,
		8807
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 58882;
module.exports = webpackAsyncContext;